import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {MenuService} from '../../services/menu/menu-service';
import {MenuItem} from '../../models/menu.model';
import {UserService} from '../../services/user/user.service';

@Component({
  selector: 'app-menu-global',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './menu-global.html',
  styleUrl: './menu-global.scss'
})
export class MenuGlobal {
  constructor(
    readonly menuService: MenuService,
    protected readonly userService: UserService
  ) {}

  toggleMenu(): void {
    (document.querySelector('#sidebar') as HTMLElement | null)?.classList.toggle('open');
  }

  /**
   * Gestisce il click sugli elementi del menu.
   * Su mobile (<= 1024px), se l'azione comporta navigazione (nessun child e route presente),
   * chiude anche il menu tramite toggleMenu(), come fa il pulsante "menu-toggle close".
   */
  onMenuItemClick(item: MenuItem): void {
    // Esegue la logica standard (navigazione o espansione)
    this.menuService.navigateTo(item);

    // Se siamo su mobile e l'item comporta una navigazione, chiudiamo il menu
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 1024;
    const willNavigate = !item?.children?.length && !!item?.route;
    if (isMobile && willNavigate) {
      this.toggleMenu();
    }
  }
}
